export function toTimeInteger(str) {
  if (!str) { return null }

  const ret = parseInt(str.replace(':', ''))
  if (isNaN(ret)) { return null }

  return ret
}

export const timeInteger = (timeInt, format = 'HH:mm') => {
  const tmp = parseInt(timeInt)
  if (isNaN(timeInt)) { return '' }
  const h = parseInt(timeInt / 100)
  const min = tmp % 100

  return format
    .replace(/HH/g, ('0' + h).slice(-2))
    .replace(/H/g, h)
    .replace(/mm/g, ('0' + min).slice(-2))
    .replace(/m/g, min)
}
